// extracted by mini-css-extract-plugin
export default {"mainbox":"lb_mainbox__v-bET","root":"lb_root__2kSdR","app":"lb_app__tK4hu","content":"lb_content__yznPf"};